import React from "react";
import { useQuery } from "react-query";
import { getManageCaseApplication } from "./gateway";
import { AxiosError, AxiosResponse } from "axios";
import { TManageCaseApplication } from "./types";
import { useAuth } from "src/shared/context/useAuth";
import { enqueueSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { useBrowserBack } from "src/shared/context/BrowserBack";
import { useNavigate } from "react-router-dom";

export default function useGetManageCaseApplication(caseId: number) {
  const { userHomePath } = useAuth();
  const { t } = useTranslation();
  const { previousPage } = useBrowserBack();
  const navigate = useNavigate();

  return useQuery<AxiosResponse<TManageCaseApplication>, AxiosError<string>>({
    queryFn: () => getManageCaseApplication(caseId),
    queryKey: ["manageCaseApplication", caseId],
    onSuccess: (data: AxiosResponse<TManageCaseApplication>) => {
      if (!!data.data.caseIsCompeted) {
        window.scrollTo({
          top: 10,
          behavior: "smooth",
        });
      }
    },
    onError: (error: AxiosError<string>) => {
      enqueueSnackbar(
        error?.response?.data ??
          t("Κάποιο Σφάλμα Σηνέβη, Προσπαθήστε Αργότερα"),
        { variant: "error" },
      );

      navigate(previousPage || userHomePath);
    },
    enabled: !!caseId,
  });
}
